import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import "./mailto.js"

// Stimulus
import { Application } from "@hotwired/stimulus"
import HeroGridController from "./controllers/hero_grid_controller.js"
import ScrollTopController from "./controllers/scroll_top_controller.js"

const application = Application.start()
application.register("hero-grid", HeroGridController)
application.register("scroll-top", ScrollTopController)

console.info("Bridgetown is loaded!")
